module.exports = __webpack_public_path__ + "static/media/close.2220a3d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/view/order/close.svg
// module id = 1022
// module chunks = 0